<template>
  <div class="security-container">
    <!-- 登陆密码 -->
    <div class="security-card">
      <div class="card-left">
        <div class="icon-wrapper password-icon">
          <img src="./assets/img/password.png" alt="密码" class="icon">
        </div>
        <div class="card-content">
          <h3 class="card-title">登陆密码</h3>
          <p class="card-desc">用于保护账号信息安全</p>
        </div>
      </div>
      <div class="card-right">
        <span class="status-text status-set">已设置</span>
        <button class="btn-modify">修改</button>
      </div>
    </div>

    <!-- 手机号绑定 -->
    <div class="security-card">
      <div class="card-left">
        <div class="icon-wrapper phone-icon">
          <img src="./assets/img/phone.png" alt="手机" class="icon">
        </div>
        <div class="card-content">
          <h3 class="card-title">手机号绑定</h3>
          <p class="card-desc">已绑定手机: 138****8957</p>
        </div>
      </div>
      <div class="card-right">
        <span class="status-text status-set">已绑定</span>
        <button class="btn-modify">修改</button>
      </div>
    </div>

    <!-- 电子邮箱绑定 -->
    <div class="security-card">
      <div class="card-left">
        <div class="icon-wrapper email-icon">
          <img src="./assets/img/email.png" alt="邮箱" class="icon">
        </div>
        <div class="card-content">
          <h3 class="card-title">电子邮箱绑定</h3>
          <p class="card-desc">用于接收重要通知及找回密码</p>
        </div>
      </div>
      <div class="card-right">
        <span class="status-text status-unset">未绑定</span>
        <button class="btn-bind">绑定</button>
      </div>
    </div>

    <!-- 微信绑定 -->
    <div class="security-card">
      <div class="card-left">
        <div class="icon-wrapper wechat-icon">
          <img src="./assets/img/wechat.png" alt="微信" class="icon">
        </div>
        <div class="card-content">
          <h3 class="card-title">微信绑定</h3>
          <p class="card-desc">绑定后可使用微信扫码登陆</p>
        </div>
      </div>
      <div class="card-right">
        <span class="status-text status-unset">未绑定</span>
        <button class="btn-bind">绑定</button>
      </div>
    </div>

    <!-- 实名认证 -->
    <div class="security-card">
      <div class="card-left">
        <div class="icon-wrapper auth-icon">
          <img src="./assets/img/check.png" alt="认证" class="icon">
        </div>
        <div class="card-content">
          <h3 class="card-title">实名认证</h3>
          <p class="card-desc">完成实名认证,保障账号安全</p>
        </div>
      </div>
      <div class="card-right">
        <span class="status-text status-unset">未认证</span>
        <button class="btn-bind">认证</button>
      </div>
    </div>

    <!-- 注销账号 -->
    <div class="security-card warning-card">
      <div class="card-left">
        <div class="icon-wrapper warning-icon">
          <img src="./assets/img/warming.png" alt="警告" class="icon">
        </div>
        <div class="card-content">
          <h3 class="card-title warning-title">注销账号</h3>
          <p class="card-desc warning-desc">注销后,您将无法使用当前账号,账号绑定的相关信息将被清空且无法恢复。请谨慎操作!</p>
        </div>
      </div>
      <div class="card-right">
        <button class="btn-delete">申请注销账号</button>
      </div>
    </div>
  </div>
</template>

<script>
export default { 
  name: 'PersonalSecurity',
  methods: {
    handleModifyPassword() {
      // 处理修改密码
      console.log('修改密码');
    },
    handleModifyPhone() {
      // 处理修改手机号
      console.log('修改手机号');
    },
    handleBindEmail() {
      // 处理绑定邮箱
      console.log('绑定邮箱');
    },
    handleBindWechat() {
      // 处理绑定微信
      console.log('绑定微信');
    },
    handleAuth() {
      // 处理实名认证
      console.log('实名认证');
    },
    handleDeleteAccount() {
      // 处理注销账号
      console.log('申请注销账号');
    }
  }
};
</script>

<style scoped>
.security-container {
  padding: 0;
}

.security-card {
  background: white;
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-left {
  display: flex;
  align-items: center;
  flex: 1;
}

.icon-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.password-icon,
.phone-icon,
.email-icon,
.auth-icon {
  background: transparent;
}

.wechat-icon {
  background: transparent;
}

.warning-icon {
  background: transparent;
}

.icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.card-content {
  flex: 1;
}

.card-title {
  font-size: 15px;
  font-weight: 500;
  color: #333;
  margin: 0 0 3px 0;
}

.warning-title {
  color: #d63031;
}

.card-desc {
  font-size: 13px;
  color: #666;
  margin: 0;
  line-height: 1.3;
}

.warning-desc {
  color: #333;
}

.card-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.status-text {
  font-size: 13px;
  font-weight: 500;
}

.status-set {
  color: #00b894;
}

.status-unset {
  color: #999;
}

.btn-modify {
  padding: 5px 12px;
  border: 1px solid #667eea;
  background: white;
  color: #667eea;
  border-radius: 5px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-modify:hover {
  background: #667eea;
  color: white;
}

.btn-bind {
  padding: 6px 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-bind:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.btn-delete {
  padding: 6px 16px;
  border: 1px solid #ff4757;
  background: white;
  color: #ff4757;
  border-radius: 5px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-delete:hover {
  background: #ff4757;
  color: white;
}

.warning-card {
  background: #fff5f5;
  border: 1px solid #ffcdd2;
}
</style>